import React, { useEffect, useRef, useState } from 'react';
import { utilizationApi } from '../../services';
import { Table, Pagination } from '../common/molecules';
import { networkSchema, homeCollectionSchema } from '../../schemas/table';
import { no_data_icon, pathIcon, popup_close as closebtn, searchIcon, download, greenTickThick } from '../../assets/images';
import { Tabbar } from '../common/molecules';
import { handleAppError } from '../handlers';
import { Breadcrumb } from '../common/atoms';
import DropdownWithSearch from '../molecules/DropdownSearch';
import Spinner from '../common/atoms/Spinner.js';
import { useLocation } from 'react-router-dom';
import { Button } from 'antd';
import { successOrFailureToaster } from '../common/atoms/messages';
import { DownloadCircularProgressModel } from '../modals';
import { SALES_ROLE } from '../../constants/overview';
const ViewPage = (props) => {
  const [heading1, setHeading1] = useState(["enterprises Name", "Branch Name", "Outsourced facilities", "City"])
  const [data, setData] = useState({})
  const [data2, setData2] = useState([])
  const [homeCollDefaultData, setHomeCollDefaultData] = useState({})
  const [loading, setLoading] = useState(true)
  const contents = useRef([{ text: "In-clinic" }, { text: "Home collection" }])
  const [selectContent, setSelectContent] = useState({ text: "In-clinic" })
  const [curPage, setCurPage] = useState(0)
  const [benefitsId, setBenefitsId] = useState()
  const [totalPage, setTotalPage] = useState(0)
  const [totalCount, setTotalCount] = useState()
  const [homeData, setHomeData] = useState([])
  const [enterpriseName, setEnterpriseName] = useState('')
  const [cityName, setCityName] = useState('')
  const [page1, setPage1] = useState(1)
  const [headers2, setHeaders2] = useState([])
  const [isHeadingCheck2, setIsHeadingCheck2] = useState(true)
  const [allProvider, setAllProvider] = useState([])
  const [allCities, setAllCities] = useState([])
  const [searchValue, setSearchValue] = useState()
  const [progressValue, setProgressValue] = useState(0)
  const intervalId = useRef('intial value')
  const abortId = useRef('abort id')
  const [downloadModel, setDownloadModel] = useState(false)
  const [downloadedFile, setDownloadedFile] = useState(false)
  const [btnState, setBtnState] = useState(false)
  
  let location = useLocation()

  const content = (selectedContractObj) => {
    if (!selectContent.loading) {
      if (selectedContractObj?.text === "In-clinic") {
        return Onsite()
      } else if (selectedContractObj?.text === "Home collection") {
        return Homecare()
      }
    } else {
      setSelectContent({ ...selectContent, loading: true })
      return Onsite()
    }
  };

  const updateCityList = (arg) => {
    let enterprise = allProvider.find((e) => e.name === arg)
    let benefit_type = benefitType(location?.state?.type)
    let companyId = sessionStorage.getItem('company_id')
    let startDate = location?.state?.start_date
    let endDate = location?.state?.end_date
    let contractId = location?.state?.contract_id ?? ''
    let options = { id: benefitsId, enterprise_id: enterprise?.id, params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }
    utilizationApi.networkCityList(options, (res) => setAllCities(res.data?.cities), err => { handleAppError(err) })
  }

  const selectEnterprise = (data) => {
    if (data.name) {
      setEnterpriseName(data.name)
      updateCityList(data.name)
      setCityName('')
    }
  }

  const searchHomeCollection = (e) => { setSearchValue(e.target.value) }

  const benefitType = (key) => {
    switch (key) {
      case 'Health checks':
        return 'ahc'        
      case 'Dental Checks':
        return 'dental'
      case 'Vision Checks':
        return 'vision'
      default:
        return 'ahc'
    }
  }

  useEffect(() => {
    if (String(searchValue).length === 6) {
      let benefit_type = benefitType(location?.state?.type)
      let startDate = location?.state?.start_date
      let endDate = location?.state?.end_date
      let contractId = location?.state?.contract_id ?? ''
      let companyId = sessionStorage.getItem('company_id')
      let options = { id: benefitsId, page: 1, pincode: searchValue, params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId  } }
      setLoading(true)
      utilizationApi.healthChecksHomeCollectionView(options, onSuccess, err => { handleAppError(err) })
    } else {
      setHeaders2([])
      setHomeData([])
      setTotalPage(0)
      setTotalCount(0)
    }
  }, [searchValue])

  const selectCity = (data) => { if (data.city) setCityName(data.city) }

  const cityAndEnterprise = () => {
    setCityName('')
    setEnterpriseName('')
    let benefit_type = benefitType(location?.state?.type)
    let startDate = location?.state?.start_date
    let endDate = location?.state?.end_date
    let contractId = location?.state?.contract_id ?? ''
    let companyId = sessionStorage.getItem('company_id')
    let options = { id: benefitsId, params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }
    utilizationApi.networkCityList(options, (res) => { setAllCities(res.data?.cities) }, err => { handleAppError(err) })
    utilizationApi.networkEnterpriseList(options, (res) => { setAllProvider(res.data?.enterprises) }, err => { handleAppError(err) })
    setLoading(true)
    utilizationApi.healthChecksFetchView(options, onSuccess, err => { handleAppError(err) })
  }

  const clearCity = () => { location.state.benefit_id && cityAndEnterprise() }

  const clearEnterprise = () => { location.state.benefit_id &&  cityAndEnterprise() }

  const changeContractId = (contract) => {
    if (contract?.text === "In-clinic") {
      setSelectContent({ text: contract?.text, loading: false });
      updateContent(contract?.text)
    } else if (contract?.text === "Home collection") {
      setSelectContent({ text: contract?.text, loading: false });
      updateContent(contract?.text)
    }
  };

  const updateContent = (select) => {
    setLoading(true)
    let startDate = location?.state?.start_date
    let endDate = location?.state?.end_date
    let benefit_type = benefitType(location?.state?.type)
    let companyId = sessionStorage.getItem('company_id')
    let contractId = location?.state?.contract_id ?? ''
    if (select === "Home collection") {
      let options = { id: benefitsId, page: page1, params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }
      location.state.benefit_id && utilizationApi.healthChecksHomeCollectionView(options, onSuccess, err => { handleAppError(err) })
    } else if (select === "In-clinic") {
      let options = { id: benefitsId, page: page1, params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }
      location.state.benefit_id && utilizationApi.healthChecksFetchView(options, onSuccess, err => { handleAppError(err) })
    }
    setLoading(false)
  }

  const updateViewLogData = (page) => {
    if (selectContent?.text === 'In-clinic') { filterSearch(page) }
    else if (selectContent?.text === "Home collection") {
      let benefit_type = benefitType(location?.state?.type)
      let startDate = location?.state?.start_date
      let endDate = location?.state?.end_date
      let companyId = sessionStorage.getItem('company_id')
      let contractId = location?.state?.contract_id ?? ''
      let options = { page: page, id: benefitsId, pincode: searchValue, params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } };
      utilizationApi.healthChecksHomeCollectionView(options, onSuccess, err => { handleAppError(err) })
    }
  }

  const paginateData = (page) => {
    setCurPage(page)
    setPage1(page + 1)
    setLoading(true)
    updateViewLogData(page + 1)
  };

  useEffect(() => {
    setPage1(page1)
  }, [page1])

  const onSuccess = (dataFetch) => {
    setSelectContent((prev) => {
      if (prev?.text === "In-clinic") {
        setData(dataFetch.data)
        setTotalPage(dataFetch.data.total_page + 1)
        setTotalCount(dataFetch.data.total_count)
      } else if (prev?.text === "Home collection") {
        if (isHeadingCheck2) {
          setCurPage(0)
          setIsHeadingCheck2(false)
          setHomeCollDefaultData(dataFetch.data)
        } else {
          if (Object.keys(dataFetch.data)?.includes("result") && dataFetch.data?.result?.length > 0) {
            setHeaders2(["pincode_area", ...Object.keys(dataFetch?.data?.result[0]?.miss_data)]);
            setHomeData(dataFetch.data.result)
            setTotalPage(dataFetch.data.total_page + 1)
            setTotalCount(dataFetch.data.total_count)
          } else {
            setHeaders2([])
            setHomeData([])
            setTotalPage(0)
            setTotalCount(0)
            setCurPage(0)
          }
        }
      }
      setLoading(false);
      return prev;
    });
  };  

  const filterSearch = (page = -1) => {
    setLoading(true)
    let benefit_type = benefitType(location?.state?.type)
    let startDate = location?.state?.start_date
    let endDate = location?.state?.end_date
    let companyId = sessionStorage.getItem('company_id')
    let contractId = location?.state?.contract_id ?? ''
    if (enterpriseName !== '' && cityName !== '') {
      let enterprise = allProvider.find((e) => e.name === enterpriseName);
      let options = {
        id: benefitsId, page: page == -1 ? page1 : page,
        enterprise_id: enterprise?.id, city: cityName,
        params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId }
      }
      utilizationApi.healthChecksFetchView(options, onSuccess, err => { handleAppError(err) })
    } else if (enterpriseName === '' && cityName !== '') {
      let options = { id: benefitsId, page: page == -1 ? page1 : page, city: cityName,
                      params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }
      utilizationApi.healthChecksFetchView(options, onSuccess, err => { handleAppError(err) })
    } else if (enterpriseName !== '' && cityName === '') {
      let enterprise = allProvider.find((e) => e.name === enterpriseName)
      let options = { id: benefitsId, page: page == -1 ? page1 : page, enterprise_id: enterprise?.id,
                      params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }
      utilizationApi.healthChecksFetchView(options, onSuccess, err => { handleAppError(err) })
    } else {
      let options = { id: benefitsId, page: page == -1 ? page1 : page,
                      params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }
      utilizationApi.healthChecksFetchView(options, onSuccess, err => { handleAppError(err) })
    }
  }
  
    useEffect(() => {
      let contentData = [{ text: "In-clinic" }, { text: "Home collection" }]
      contents.current = contentData
      if(location.state.benefit_id)  CallTheApi()
      else  setLoading(false)
      setSelectContent({ text: "In-clinic" })
   }, [])

  const CallTheApi = () => {
    let benefit_type = benefitType(location?.state?.type)
    let startDate = location?.state?.start_date
    let endDate = location?.state?.end_date
    let companyId = sessionStorage.getItem('company_id')
    let contractId = location?.state?.contract_id ?? ''
    let options = { id: localStorage.getItem('benefit_id'), page: page1, params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }
    setBenefitsId(localStorage.getItem('benefit_id'))
    utilizationApi.healthChecksFetchView(options, onSuccess, err => { handleAppError(err) })
    utilizationApi.benefitPackageDescription({ id: localStorage.getItem('benefit_id'), params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }, (res) => {
      setHeading1(heading1.concat(Object.keys(res.data?.table_index)))
      let con = Object.entries(res.data?.table_index).reduce((res, arr) => {
        let obj = {}
        obj['masking_id'] = arr[0]
        obj['data'] = arr[1]
        return [...res, obj]
      }, [])
      setData2(con)
    }, err => { handleAppError(err) })
    utilizationApi.networkCityList(options, (res) => { setAllCities(res.data?.cities) }, err => { handleAppError(err) })
    utilizationApi.networkEnterpriseList(options, (res) => { setAllProvider(res.data?.enterprises) }, err => { handleAppError(err) })
    setLoading(false)
  }  

  const goBack = () => { 
      if (btnState)  abortPolling("Downloading cancelled")
      props.history.goBack(); 
  };

  const colors = ["#84C8F0", "#6891E8", "#FFA584", "#FFC697"]

  const homeCollAndNetworkUse = (arg) => {
    return <div className='flex flex-wrap' style={{ marginBottom: "50px", marginTop: "20px" }}>
      {data2.map((item, id) =>
        <div key={item.masking_id} className='w-1/2 flex-col mt-1'>
          <div className='flex gap-x-2'>
            <div className='w-4 h-4' style={{ backgroundColor: colors[id % colors.length] }}></div>
            <p className='font-bold text-sm text-black uppercase '>MASKING ID: <span className='font-bold'>{item.masking_id}</span></p>
          </div>
          <div className='mr-12'>
            {arg === "homeCollection" ? <p className="flex text-gray-300 bg-gray-100 gap-x-1 font-semibold text-xs">This package served at <span className='text-blue-500'>
              {homeCollDefaultData[item?.masking_id]} pincodes</span></p> : ''}
            <p className='font-semibold text-grey-300'><span className='font-bold text-black'>Packages with masking id: </span>{item?.data['package_name']}</p>
            <p className='font-semibold text-grey-300'><span className='font-bold text-black pr-1'>Facilities included in the packages: 
            </span>{item?.data['facilities'] ? item?.data['facilities'] : 'None'}</p>
          </div>
        </div>)}
    </div>
  }

  const PaginationFunc = () => {
    return <Pagination loading={loading} totalpages={totalPage}
      totalresults={totalCount} curpage={curPage} handler={paginateData}
    />
  }

  const Homecare = () => {
    return (
      <React.Fragment>
        <div className='min-h-screen'>
          {homeCollAndNetworkUse("homeCollection")}
          {!loading && <div style={{ "margin-inline-start": 0 }}
            className='flex align-baseline text-gray-300 bg-white text-sm items-center mx-3  py-3 pl-3.5 border mb-3 rounded-md'>
            <label htmlFor='input-search'><img pointer className='mr-3' src={searchIcon} height='13px' width='13px' /></label>
            <input id='input-search' type="number" value={searchValue} 
              onChange={(e) => location.state.benefit_id && searchHomeCollection(e)}
              placeholder='Search home collection by pincode'
              className='w-full bg-gray-full border-none focus:ring-0 font-semibold text-sm' />
          </div>}
            { !location.state.benefit_id &&
              <React.Fragment >
                <div className='grid grid-cols-1 py-16'>
                  <img src={no_data_icon} alt='no-data-icon' className='h-14 w-16 inline-block  m-auto' />
                  <span className='m-auto text-base font-semibold text-gray-600 mt-2'>No data found</span>
                </div>  
              </React.Fragment>
            }  
          <Spinner visible={loading}>
            {homeData.length > 0 && <p className='text-gray-300 text-sm font-semibold pt-4'>Search result</p>}
            {homeData.length > 0 && <Table loading={loading} headers={headers2}
              loaderHeight={300} data={homeData || []}
              tableClasses={'alternate_gray200_color'} tableschema={homeCollectionSchema}
            />}
          </Spinner>
          {homeData.length > 0 ? PaginationFunc() : ''}
        </div>
      </React.Fragment>
    )
  }

  const Onsite = () => {
    return <React.Fragment>
      {homeCollAndNetworkUse('')}
      <div className="flex gap-x-8 mb-6 bg-white py-3 px-4">
        {!loading && <DropdownWithSearch
          listItems={allProvider} type='name'
          title={enterpriseName === '' ? "Select enterprise" : `${enterpriseName}`}
          border={`border border-blue-400`} padding={'py-2.5 px-2.5'}
          borderRadius={'rounded-md'} suffixIcon={pathIcon}
          onChange={selectEnterprise} margin={'mr-3'}
          prefixIcon={searchIcon} clearText={'Clear Enterprise'}
          clearSelection={clearEnterprise}
        />}
        <div>
          {!loading && <DropdownWithSearch listItems={allCities} type='city'
            title={cityName === '' ? "Select city" : `${cityName}`}
            border={`border border-blue-400`} padding={'py-2.5 px-2.5'}
            borderRadius={'rounded-md'} suffixIcon={pathIcon}
            onChange={selectCity} clearText={'Clear City'}
            clearSelection={clearCity} prefixIcon={searchIcon}
          />}
        </div>
        {!loading && <button className='rounded-md py-3 px-6 border-solid border border-white-500 bg-white text-sm font-semibold text-blue-500 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-rose-500'
          onClick={() => { (cityName || enterpriseName) && filterSearch(1); setCurPage(0) }} >Apply Filter</button>}
      </div>
      <Spinner visible={loading}>
        <Table loading={loading} headers={heading1}
          loaderHeight={300} data={data.providers || []}
          tableClasses={'alternate_gray200_color'}
          tableschema={networkSchema}
        />
        {PaginationFunc()}
      </Spinner>
    </React.Fragment>
  }

  const downloadCSVData =  () => {
    if(!benefitsId || (data.providers?.length ?? 0) === 0){
      successOrFailureToaster({ message: 'No Data for download', type: 'fail' }) 
      return
    }
    setDownloadedFile(false)
    let benefit_type = benefitType(location?.state?.type)
    let startDate = location?.state?.start_date
    let endDate = location?.state?.end_date
    let companyId = sessionStorage.getItem('company_id')
    let contractId = location?.state?.contract_id ?? ''
    utilizationApi.fetchDataForDownloadNetworkProviders({ id: benefitsId, params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }, 
      (_) => {
        setBtnState(true)
        setDownloadModel(true)
        intervalId.current = setTimeout(() => downloadNetworkList(), 0)
        abortId.current =  setTimeout(abortPolling, 1000 * 100 * 1)
      }, 
    err => {  handleAppError(err) })
  }

  const downloadNetworkList =  () =>{
    let benefit_type = benefitType(location?.state?.type)
    let startDate = location?.state?.start_date
    let endDate = location?.state?.end_date
    let companyId = sessionStorage.getItem('company_id')
    let contractId = location?.state?.contract_id ?? ''
    utilizationApi.downloadNetworkProviders({ id: benefitsId, params: { benefit_type: benefit_type, start_date: startDate, end_date: endDate, company_id: companyId, contract_id: contractId } }, 
      (res) => {
        clearTimeout(intervalId.current)
        clearTimeout(abortId.current)
        setProgressValue(0) 
        setDownloadedFile(true)
        setBtnState(false)
        const link = document.createElement('a');
        link.href = res.data.url.url;
        link.setAttribute('download', 'Network_list'+".xlsx");
        document.body.appendChild(link);
        link.click();
      }, 
    _ => { 
      setProgressValue(prev => {
        if(prev <= 96) return prev + 1
        else return prev
      })
      intervalId.current = setTimeout(() =>  downloadNetworkList(), 1000 * 1)
    })
  }

  const abortPolling = (error) => {
    error =  error || 'Taking too long to download!'
    clearTimeout(intervalId.current)
    clearTimeout(abortId.current)
    successOrFailureToaster({ message: error, type: 'fail' }) 
    setDownloadModel(false)
    setBtnState(false)
  }

  return (
    <React.Fragment>
      {<div className='p-8 bg-gray-100 min-h-screen'>
        <Breadcrumb 
          list={[
            { text: 'Utilization', link: '/utilization/ahc' },
            { text: location.state.type, link: location.state.link },
            { text: 'Provider networks', link: '#' }
          ]} 
          classes='mb-1' 
        />
        <p className='text-black text-xl leading-loose font-semibold' >Provider networks</p>
        <img src={closebtn} alt='close-btn' className='absolute right-6 top-8 cursor-pointer h-8 w-8' onClick={goBack} />
        <div className='flex flex-row justify-between w-full sticky top-0 z-20 bg-gray-100'>
          <div style={{width : '82%'}} className='xl:w-5xl'>
            <Tabbar 
              list={contents.current} 
              loading={loading}
              classes='mt-5' 
              currentPage={selectContent?.text }
              setContract={changeContractId} 
            />
          </div>
            { !btnState ? 
                <button className={`bg-blue-600 flex flex-row border-gray-275 border leading-5 py-3 px-7 sm:w-64 rounded-md font-semibold text-base text-white mt-6 ${SALES_ROLE === 'sales' ? 'cursor-not-allowed' : 'cursor-pointer'}`} disabled={SALES_ROLE === "sales"} style={{height :'46px'}} type='button' 
                onClick={downloadCSVData}
                > 
                  <img src={download} alt='icon' className='mr-1' style={{width: '20px'}}/>
                    Download Network list
                </button>
              :  
              <div className='sm:w-64 mt-6 flex bg-blue-600 flex-row w-full  border-gray-275 border rounded-md ' style={{height :'46px'}}>
                <button className={`flex leading-5 py-3 px-3 rounded-md font-semibold text-base text-white ${SALES_ROLE === 'sales' ? 'cursor-not-allowed' : 'cursor-pointer'}`}disabled={SALES_ROLE === "sales"}  type='button' onClick={downloadCSVData}> 
                <img src={download} alt='icon' className='mr-1' style={{width: '20px'}}/>
                    Download In Progress
                </button>
                <Button type="primary" shape="circle" style={{width: '20px', marginTop : '2px'}} loading />
              </div>  
            }
       
        </div>
        {content(selectContent)}
        {  downloadModel &&
          <DownloadCircularProgressModel  
            visible={true}
            title={<p className='text-xl leading-5 font-semibold text-gray-700'>{ downloadedFile ? "Download completed" :   "Preparing data..." }</p>}
            description={<p className='text-base leading-5 mt-8 text-gray-600'>
                          { downloadedFile  ?  
                            'File is saved on your computer, and a copy is sent to your registered email address.' 
                            : 
                            ( progressValue <  98
                              ?   
                                <>                          
                                  <p className='-mt-3'>Your download is getting ready, please wait for download to start.</p>
                                  <p className='mt-3'>This may take few minutes for larger network.</p>
                                </>
                              : 
                                <>
                                  <p className='-mt-3'> Your download may take few more minutes for your extensive network.</p>
                                  <p className='mt-2'>You may continue browsing, to receive a copy to your registered email address when the file is ready.</p>
                                </>
                            )
                          }
                          </p>
                        }
            btnText={ downloadedFile ? 'Done' :'Cancel'}
            btnClasses= { downloadedFile ? 'text-white bg-blue-600 mt-6' : 'text-blue-600 mt- bg-white border-2 border-gray-200'}
            icon={downloadedFile ? greenTickThick : ''}
            width={ downloadedFile ? 596 : 596}
            height={ downloadedFile ? 338 : (progressValue <  98 ? 433 : 456)}
            dashArray={[progressValue , 100]}
            onCancel={() =>  {
              setDownloadModel(false)
            }}
            handler={() =>  {
              setDownloadModel(false)
            }}
          />
        }
      </div>}
    </React.Fragment>
  )
}
export default ViewPage